export default {
  relatedEye: 'w-20 h-15 mr-10',
  relatedArticles: {
    mediaWrapper: 'mediaWrapper',
    card: {
      card: 'card',
      mainWrapper: {
        generic:
          'bg-white-grey-lighter related-product-wrapper text-center overflow-hidden  sm:w-full recent-view flex flex-col',
        notLastChild: ' pt-40 md:pt-20',
        notLastChildNew: 'md:pt-20',
        lastChild: 'sm:border-0',
      },

      content: 'content',
      titleWrapper: 'titleWrapper ',
      shortDescription: 'shortDescription',
      media: 'media',
      header: 'header no-underline',
      button: 'button',
      viewCount: 'viewCount flex text-grey',
      eyeIconStyles: 'eyeIconStyles mr-10',
      viewCountWrapper: 'font-HelveticaNeueMedium text-base absolute bottom-0',
      title:
        'title sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-20 md:mt-20 sm:mt-20 text-left',
    },
  },
};
